module.exports = __webpack_public_path__ + "static/media/pending.ea22cea9.svg";